import * as actionTypes from '../actionTypes'

import { saveFileFromResponse } from '../../../helpers/utils'
import { enqueueSnackbar } from '../alert'
import reportAxios from '../../../axios/report'

export const reportAppraisalByLevel = recordData => {
  return dispatch => {
    dispatch(reportAppraisalByLevelStart())

    reportAxios
      .post('/report_appraisal_report_by_level', recordData, { responseType: 'blob' })
      .then(response => {
        // if (recordData.format === 'xls') {
        saveFileFromResponse(response)
        // }
        dispatch(
          enqueueSnackbar({
            message: 'Report Appraisal By Level',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(reportAppraisalByLevelSuccess(response.data))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: 'Error Report Appraisal By Level',
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(reportAppraisalByLevelFailed())
      })
  }
}

export const reportAppraisalByLevelStart = () => {
  return {
    type: actionTypes.REPORT_APPRAISAL_BY_LEVEL_START
  }
}

export const reportAppraisalByLevelSuccess = data => {
  return {
    type: actionTypes.REPORT_APPRAISAL_BY_LEVEL_SUCCESS,
    data
  }
}

export const reportAppraisalByLevelFailed = () => {
  return {
    type: actionTypes.REPORT_APPRAISAL_BY_LEVEL_FAILED
  }
}

export const clearReportAppraisalByLevel = () => {
  return {
    type: actionTypes.CLEAR_REPORT_APPRAISAL_BY_LEVEL
  }
}
